<template>
    <swiper :showScrollbar="true" :center="true" class="cz2__review-views cz2__sb-review-views">
        <div class="cz2__review-views--wrapper">
            <span class="cz2__sr-only">
                {{ $t('SR_ACTIVATING') }}
            </span>

            <button
                :class="[
                    {
                        'cz2__review-views__view--active': view === popView && selectedPack == null,
                        'cz2__review-views__view--pop': popPreviewImage == null,
                    },
                    isTwoPack ? 'cz2__review-views__view--pop-pack' : 'cz2__review-views__view--pop-single',
                ]"
                type="button"
                @click="selectView(popView, null)"
                :aria-current="view === popView && selectedPack == null"
                aria-label="View pop out of box"
                class="cz2__review-views__view"
            >
                <span
                    class="cz2__review-views__view-image"
                    :style="{
                        backgroundImage: popPreviewImage ? `url(${popPreviewImage})` : null,
                    }"
                />
            </button>

            <span class="cz2__review-views--divider" />

            <button
                :class="[
                    {
                        'cz2__review-views__view--active': view === boxView && selectedPack == null,
                        'cz2__review-views__view--box': boxPreviewImage == null,
                    },
                    isTwoPack ? 'cz2__review-views__view--box-pack' : 'cz2__review-views__view--box-single',
                ]"
                type="button"
                @click="selectView(boxView, null)"
                :aria-current="view === boxView && selectedPack == null"
                aria-label="View pop in box"
                class="cz2__review-views__view"
            >
                <span
                    class="cz2__review-views__view-image"
                    :style="{
                        backgroundImage: boxPreviewImage ? `url(${boxPreviewImage})` : null,
                    }"
                />
            </button>

            <template v-for="pack in selectedPacks">
                <span
                    :key="`${pack.controller.id}-${pack.component.code}-div`"
                    class="cz2__review-views--divider"
                />

                <button
                    :key="`${pack.controller.id}-${pack.component.code}-pack`"
                    :class="[
                        {
                            'cz2__review-views__view--active': view === popView && selectedPack?.component?.code === pack.component.code,
                            'cz2__review-views__view--box': boxPreviewImage == null,
                        },
                        isTwoPack ? 'cz2__review-views__view--box-pack' : 'cz2__review-views__view--box-single',
                    ]"
                    type="button"
                    @click="selectView(popView, pack)"
                    :aria-current="view === popView && selectedPack?.component?.code === pack.component.code"
                    aria-label="View pop"
                    class="cz2__review-views__view cz2__review-views__view--pack"
                >
                    <span
                        class="cz2__review-views__view-image"
                        :style="{
                            backgroundImage: packPreviewImage(pack) ? `url(${packPreviewImage(pack)})` : null,
                        }"
                    />
                </button>
            </template>

            <span
                v-if="view === popView && selectedPack == null"
                class="cz2__review-views__indicator cz2__review-views__indicator--out-of-box"
                :aria-label="viewCopy"
            >
                <span>{{ viewCopy }}</span>
            </span>

            <span
                v-if="view === boxView && selectedPack == null"
                class="cz2__review-views__indicator cz2__review-views__indicator--in-box"
                :aria-label="viewCopy"
            >
                <span>{{ viewCopy }}</span>
            </span>

            <span
                v-if="selectedPack != null"
                class="cz2__review-views__indicator cz2__review-views__indicator--pack"
                :aria-label="viewCopy"
                :style="{
                    backgroundImage: `url(&quot;${packBanner(selectedPack)}&quot;)`,
                }"
            >
                <span>{{ viewCopy }}</span>
            </span>
        </div>
    </swiper>
</template>

<style lang="scss">
    @import "../style/variables.scss";

    #cz2.cz2 {
        .cz2__sb-review-views {
            display: flex;
            flex-direction: row;
            justify-content: center;

            @include respond-above(lg) {
                height: 100%;

                overflow: auto;

                display: flex;
                flex-direction: column;

                justify-content: flex-start;
                align-content: center;
                align-items: center;

                padding-top: 80px;
                padding-bottom: 80px;
            }

            .cz2__review-views--wrapper {
                flex-direction: row;
                align-items: center;
                justify-content: center;

                @include respond-below(lg) {
                    gap: 4px;
                }

                @include respond-above(lg) {
                    padding-top: 20px;
                    padding-bottom: 20px;

                    flex-direction: column;

                    justify-content: center;
                    align-content: center;
                    align-items: center;

                    gap: 16px;

                    margin-top: auto;
                    margin-bottom: auto;
                }
            }

            .cz2__review-views--divider {
                flex: 0 0 auto;

                width: 3px;
                height: 60px;

                @media (max-width: 390px) {
                    width: 2px;
                }

                background: #E7C267;

                @include respond-above(lg) {
                    width: 144px;
                    height: 4px;
                }
            }

            .cz2__review-views__view-image {
                background-position: center;
                background-repeat: no-repeat;
            }

            .cz2__review-views__view {
                @include respond-above(md) {
                    width: 140px;
                    height: 90px;
                }
            }

            .cz2__review-views__view.cz2__review-views__view--pack {
                width: 40px;
                height: 40px;

                @include respond-above(lg) {
                    width: 110px;
                    height: 110px;
                }
            }

            .cz2__review-views__indicator {
                display: none;

                @include respond-above(lg) {
                    display: block;

                    margin-top: 16px;

                    width: 220px;
                    height: 90px;

                    background-image: none;
                    background-size: contain;
                    background-repeat: no-repeat;

                    span {
                         display: none;
                    }

                    &.cz2__review-views__indicator--out-of-box {
                        background-image: url(../assets/images/branded/sb-final/SB-OutOfBox.webp);
                    }

                    &.cz2__review-views__indicator--in-box {
                        background-image: url(../assets/images/branded/sb-final/SB-InBox.webp);
                    }
                }
            }
        }
    }

    #cz2.cz2.cz2__is-kiosk.cz2__is-sb {
        .cz2__sb-review-views {
            flex: 0 0 auto;

            width: calc(var(--vw100, 100vw) - 200px);
            height: auto;

            position: relative;
            bottom: 0;
            padding-bottom: 150px;

            display: flex;
            flex-direction: row;
            justify-content: center;
        }

        .cz2__review-views--wrapper  {
            position: relative;

            flex-direction: row;
            justify-content: center;

            gap: 12px;
        }

        .cz2__review-views--divider {
            margin: 0;

            width: 6px;
            height: 144px;
        }

        .cz2__review-views__view {
            width: 140px;
            height: 140px;

            transform: none;

            &.cz2__review-views__view--pop-single {
                transform: none;
            }

            &.cz2__review-views__view--box-single {
                transform: none;
            }

            &.cz2__review-views__view--pop-pack {
                transform: none;
            }

            &.cz2__review-views__view--box-pack {
                transform: none;
            }
        }

        .cz2__review-views__view.cz2__review-views__view--pack {
            width: 115px;
            height: 140px;

            transform: none;
        }

        .cz2__review-views__indicator {
            position: absolute;

            top: 180px;
            left: 50%;
            transform: translate(-50%, 0);
        }
    }
</style>

<script>
    import Swiper from './ui/Swiper.vue';

    export default {
        components: {
            Swiper,
        },

        data() {
            const { isTwoPack } = this.$store.getters;

            return {
                view: isTwoPack ? 'MainMiniPack' : 'Main Mini',

                selectedPack: null,
            };
        },

        computed: {
            isTwoPack() {
                return this.$store.getters.isTwoPack;
            },

            viewCopy() {
                return this.view === this.popView ? this.$t('REVIEW_OUT_OF_BOX') : this.$t('REVIEW_IN_BOX');
            },

            popPreviewImage() {
                return this.$store.state.customizer.popPreviewImage;
            },

            boxPreviewImage() {
                return this.$store.state.customizer.boxPreviewImage;
            },

            popView() {
                return this.isTwoPack ? 'MainMiniPack' : 'Main Mini';
            },

            boxView() {
                return this.isTwoPack ? 'BoxFarPack' : 'BoxFar';
            },

            selectedPacks() {
                return this.$store.getters.selectedPacks;
            },
        },

        mounted() {
            this.emitter.$on('saveSbAvatar', this.saveSbAvatar);

            this.emitter.$on('cameraLoading', this.cameraLoading);
        },

        beforeDestroy() {
            // Before leaving the step, restore packs.
            this.restorePacks();

            this.emitter.$off('saveSbAvatar', this.saveSbAvatar);

            this.emitter.$off('cameraLoading', this.cameraLoading);
        },

        methods: {
            selectView(view, pack) {
                this.view = view;
                this.selectedPack = pack;

                this.$store.dispatch('setPreferredView', view);

                if (pack) {
                    this.previewPack(pack);
                } else {
                    this.restorePacks();
                }
            },

            previewPack(pack) {
                if (pack.component.custom['fun-pack-contents']) {
                    this.$store.dispatch('setNoSavePreviews', true);

                    const contents = JSON.parse(pack.component.custom['fun-pack-contents']);

                    const saved = {};

                    const selectPackComponents = (applyChanges) => {
                        // eslint-disable-next-line no-restricted-syntax
                        for (const placementCode of Object.keys(contents)) {
                            const sku = contents[placementCode];

                            const placement = pack.controller.findPlacement(placementCode);

                            if (placement) {
                                // Technically we should not need inventory for this.
                                // But rules will prevent us from showing anything if there isn't any.
                                let component = null;

                                if (sku === '') {
                                    component = placement.components.find((x) => x.code.includes('Empty'));
                                    if (component == null) {
                                        component = placement.components.find((x) => x.placeholder);
                                    }
                                } else {
                                    component = placement.components.find((x) => x.code.includes(sku) && pack.controller.isAvailable(x));
                                }

                                if (component) {
                                    const old = pack.controller.selectedAtPlacement(placementCode);

                                    if (!applyChanges) {
                                        saved[placementCode] = old.code;
                                    }

                                    if (applyChanges) {
                                        pack.controller.updateComponent(placementCode, component.code);
                                    }
                                }
                            }
                        }
                    };

                    // Need to apply changes in two passes:
                    // First save all current selections
                    // Then apply new
                    // Otherwise by applying torsos from the pack, we may change the existing configuration.
                    selectPackComponents(false);
                    selectPackComponents(true);

                    if (this.savedPlacements == null) {
                        this.savedPlacements = {};
                    }

                    // If there is already a saved state, means we are already showing a pack, so we need not to overwrite the state.
                    if (this.savedPlacements[pack.controller.id] == null) {
                        this.savedPlacements[pack.controller.id] = {
                            pack,
                            saved,
                        };
                    }
                }
            },

            restorePacks() {
                this.$store.dispatch('setNoSavePreviews', false);

                if (this.savedPlacements) {
                    // eslint-disable-next-line no-restricted-syntax
                    for (const pop of Object.values(this.savedPlacements)) {
                        // eslint-disable-next-line no-restricted-syntax
                        for (const placementCode of Object.keys(pop.saved)) {
                            pop.pack.controller.updateComponent(placementCode, pop.saved[placementCode]);
                        }
                    }

                    this.savedPlacements = {};
                }
            },

            packPreviewImage(pack) {
                return pack.component.custom['fun-badge-pack-icon'];
            },

            packBanner(pack) {
                return pack.component.custom['fun-badge-out-of-box'];
            },

            cameraLoading(loading) {
                if (!loading) {
                    if (this.needToSaveAvatar) {
                        this.needToSaveAvatar = false;

                        // Or can be saved right away.
                        this.$store.dispatch('saveRecipe', {
                            type: 'avatar',
                        });
                    }
                }
            },

            saveSbAvatar() {
                // Need to restore and wait until loaded.
                if (this.savedPlacements && Object.keys(this.savedPlacements).length > 0) {
                    this.needToSaveAvatar = true;

                    this.restorePacks();
                } else {
                    // Or can be saved right away.
                    this.$store.dispatch('saveRecipe', {
                        type: 'avatar',
                    });
                }
            },
        },
    };
</script>
